/* eslint-disable react/prop-types */
import { BoardIcon, ChevronDownIcon } from '@sketchnote/icons';
import { Emoji } from 'emoji-mart';
import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

import { Avatar } from '../avatar';
import { userSelectStyles } from './user';

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

export const boardSelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  ...userSelectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    ...(userSelectStyles?.option
      ? userSelectStyles?.option(styles, {
          isDisabled: isDisabled,
          isFocused: isFocused,
          isSelected: isSelected,
        } as any)
      : {}),
    lineHeight: '0px',
    padding: '1.3rem 1.5rem 1.3rem 1rem',
  }),
};

export const boardColumnSelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  ...userSelectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    ...(userSelectStyles?.option
      ? userSelectStyles?.option(styles, {
          isDisabled: isDisabled,
          isFocused: isFocused,
          isSelected: isSelected,
        } as any)
      : {}),
    lineHeight: '24px',
    padding: '1.3rem 1.5rem 1.3rem 1rem',
  }),
};

export const boardSelectDropDownIndicator = () => <ChevronDownIcon className="text-gray-500" />;

export const boardSelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    {props.data.icon ? (
      <Emoji emoji={props.data.icon} set="apple" size={24} />
    ) : (
      <BoardIcon wrapperClass="bg-gray-100 p-7 text-primary-300 rounded-sm" />
    )}
    <span className="ml-8">{props.data.label}</span>
  </div>
);

export const boardColumnSelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    <span className="px-8 py-1 rounded-sm" style={{ backgroundColor: props.data.color }}>
      {props.data.label}
    </span>
  </div>
);

export const boardSelectOption: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex">
      <div>
        {props.data.icon ? (
          <Emoji emoji={props.data.icon} set="apple" size={20} />
        ) : (
          <BoardIcon wrapperClass="bg-gray-100 text-primary-300 rounded-sm" />
        )}
      </div>
      <div>
        <span className="ml-8 mt-4 block">{props.data.label}</span>
        <span className="ml-8 flex items-center text-xs mt-24 text-gray-400">
          {`${
            props.data.workspace === 'Private' || props.data.workspace === 'Shared'
              ? 'Dashboard'
              : 'Workspace'
          } > ${props.data.workspace}`}
        </span>
      </div>
    </div>
  </SelectComponents.Option>
);

export const boardColumnSelectOption: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      <span className="px-8 py-1 rounded-sm" style={{ backgroundColor: props.data.color }}>
        {props.data.label}
      </span>
    </div>
  </SelectComponents.Option>
);
